import React from 'react';

const UploadIcon = ({ color = 'black' }) => (
  <svg
    version="1.1"
    id="Icons"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
    xmlSpace="preserve"
    className="w-full h-auto"
    preserveAspectRatio="xMidYMid meet"
  >
    <style type="text/css">
      {`.st0{fill:none;stroke:${color};stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}`}
    </style>
    <line className="st0" x1="16" y1="20" x2="16" y2="4"/>
    <polyline className="st0" points="12,8 16,4 20,8 "/>
    <polyline className="st0" points="9,13 3,16.5 3,21.5 16,29 29,21.5 29,16.5 23,13 "/>
  </svg>
);

export default UploadIcon;
